import React, { useState } from 'react';

import DataTable from 'react-data-table-component';

import useLastMembersPrograms from 'components/Common/LastMembersPrograms/Hooks/useLastMembersPrograms';
import columns from './Table/columns';
import Filters from './Table/Filters';

export default function Index({ demo }) {
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState(null);

  const programs = useLastMembersPrograms({ demo });

  const filteredPrograms = programs
    && Object.values(programs).filter((item) => {
      let available = false;
      if (
        (item.attributes.coach_full_name.toLowerCase().includes(keyword.toLowerCase())
        || item.attributes.student_full_name.toLowerCase().includes(keyword.toLowerCase()))
        && (status == null || item.attributes.status === status)
      ) available = true;

      return available;
    });

  return (
    <div>
      <Filters keyword={keyword} setKeyword={setKeyword} setStatus={setStatus} />
      <div className="datatable-style font-12">
        <DataTable
          title=""
          columns={columns}
          data={filteredPrograms || []}
          noDataComponent={(
            <div className="mt20">
              {programs == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </div>
  );
}
